import { useWindowSize } from 'react-easyrocket';
import coinsBgModal from 'src/assets/images/shop/backgrounds/coinsBgModal.webp';
import { SimpleClose } from 'src/components/svg/Closes';
import grass from 'src/assets/images/shop/other/grassShop.webp';
import arrowShop from 'src/assets/images/shop/other/arrowShop.png';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'src/hooks/useModalContext';
import { NewShopModalContainerProps } from '../types';

export const ShopModalContainer = ({ title, text, children }: NewShopModalContainerProps) => {
  const { isDesktopLayout } = useWindowSize();
  const { closeModal } = useModalContext();
  const { t } = useTranslation();
  return (
    <div
      className="1024:w-[915px] w-full min-h-[400px] 1024:min-h-[90vh] 1280:w-[992px] flex items-center justify-center overflow-hidden bg-contain bg-no-repeat bg-center"
      style={{
        backgroundImage: `url(${isDesktopLayout ? coinsBgModal : ''})`
      }}>
      <div className="1024:w-[800px] w-[90%] h-full flex flex-col items-end 1024:gap-20 gap-[15px]">
        <SimpleClose onShow={closeModal} />
        <div className="flex flex-col items-center relative z-0">
          <img src={grass} alt="grass" className="1024:min-h-[75px] min-h-[29px] relative" />
          <div
            className="absolute 1024:top-[-60px] top-[-4%] 1024:w-[403px] 768:w-[270px] 1024:h-[153px] 768:h-[102px] w-[210px] h-20 flex items-center justify-center"
            style={{ backgroundImage: `url(${arrowShop})`, backgroundSize: 'cover' }}>
            <p className="text-center text-sp_title drop-shadow-purpleForText 1024:leading-[35px] 768:leading-[25px] leading-[15px] 1024:text-[40px] 768:text-[25px] text-base font-bold 1024:max-w-[204px] max-w-[95px] w-full">
              {t(title)}
            </p>
          </div>
          <div className="bg-sp_modal_bg flex flex-col items-center rounded-b-[20px] justify-center w-full px-5">
            <p className="text-sp_text font-bold 768:text-[25px] text-base text-center pt-10 max-w-[610px] w-full">
              {t(text)}
            </p>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
